export default __webpack_public_path__ + "static/media/PinkFrame07.fae92c6c.png";